<mat-sidenav-container>
  <mat-sidenav position="end" mode="over" class="field-editor-sidebar" #rightside mat-component-id="rightside">
    <aw-edit-field [field]="fieldService.getEditCustomField()" (closePanel)="closeRightSidePanel($event)"></aw-edit-field>
  </mat-sidenav>
  <section class="container">
    @if (blockUi) {
      <div class="loading-image-container">
        <div class="loading-image small"></div>
        <div class="loading-text">Loading ...</div>
      </div>
    }
    <div class="header-wrapper">
      <img class="module-icon headerText" src="../../../../../../assets/img/{{moduleId}}.svg" />
      <span class="headerText">{{ subHeaderText }} </span>
      <span class="headerText subSubHeaderText">{{ subSubHeaderText }}</span>
      <span class="moduleVersion">{{ moduleVersion }}</span>
    </div>
    <div class="content-wrapper">
      <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="module-nav-bar">
        <a [routerLink]="['steps']" routerLinkActive="active" mat-tab-link id="module-steps-tab">Steps</a>
        @if (showStateTab(moduleId)) {
          <a [routerLink]="['state']" routerLinkActive="active" mat-tab-link id="module-state-tab">State</a>
        }
        <a [routerLink]="['linkedfields']" routerLinkActive="active" mat-tab-link id="module-linked-fields-tab">Linked Fields</a>
        <a [routerLink]="['stateviewer']" routerLinkActive="active" mat-tab-link id="module-state-viewer-tab">State Viewer (Experimental)</a>
      </nav>
      <mat-tab-nav-panel #tabPanel>
        <router-outlet></router-outlet>
      </mat-tab-nav-panel>
    </div>
  </section>
</mat-sidenav-container>
